import cn from 'classnames';
import { numberWithSeparator } from '@shared/helpers';
import styles from './index.module.scss';

interface Props {
  price: number;
  partnerPrice: number | null;
}

const Price = ({ price, partnerPrice }: Props) => (
  <div className={styles.container}>
    {partnerPrice && (
      <div className={styles.partnerPrice}>
        {`${numberWithSeparator(partnerPrice / 100)}`}
        <span className={styles.currency}> RUB (для партнеров)</span>
      </div>
    )}
    <div className={cn(styles.price, partnerPrice && partnerPrice > 0 && styles.withPartner)}>
      {`${numberWithSeparator(price / 100)}`}
      <span className={styles.currency}> RUB</span>
    </div>
  </div>
);

export default Price;
